import { useState } from "react";

import type { DeletedContentCounts } from "../ModerationControls.types";

export function useContentDeletion(personId: number) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [deletedCounts, setDeletedCounts] =
    useState<DeletedContentCounts | null>(null);

  const deleteContent = async () => {
    if (!personId || isDeleting) return;

    if (
      !window.confirm(
        "Удалить все материалы этого пользователя (проблемы, решения, карточки, комментарии)? Удалённое останется в корзине на некоторое время.",
      )
    ) {
      return;
    }

    setIsDeleting(true);
    setError(null);

    try {
      const response = await fetch(`/api/people/${personId}/delete-content/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || `Request failed: ${response.status}`);
      }

      setDeletedCounts(data?.deleted ?? null);
    } catch (e: any) {
      setError(e?.message || "Unknown error");
    } finally {
      setIsDeleting(false);
    }
  };

  return { isDeleting, error, deletedCounts, deleteContent };
}
